import {convertInquiryTypeToText, convertMailTypeToText} from "../../../utils/helpler-utils";

export default {
    SET_LIST_MAIL_DRAFT(state, listMailDraft) {
        let result = [];
        if (listMailDraft && listMailDraft.length > 0) {
            result = listMailDraft.map(element => {
                // if (element.sent_datetime) {
                //     element.sent_datetime = element.sent_datetime.substr(0, 16)
                // }
                if (typeof element.state_flg !== 'undefined') {
                    if (element.state_flg === -1) {
                        element.state_flg_text = '削除'
                    } else if (element.state_flg === 0) {
                        element.state_flg_text = '下書き'
                    } else if (element.state_flg === 1) {
                        element.state_flg_text = '送信済'
                    } else if (element.state_flg === 2) {
                        element.state_flg_text = '送信失敗'
                    } else {
                        element.state_flg_text = ''
                    }
                }
                element.type_text = convertMailTypeToText(element.type, element.kinds_name, element.kinds_state)
                element.inquiry_type_text = convertInquiryTypeToText(element.inquiry_type)
                return element
            })
        }
        state.listMailDraft = result
    },
    SET_SEARCH_FILTER(state, payload){
        state.searchFilter = payload
    },
    CLEAR_SERACH_FILTER(state){
        state.searchFilter = null
    },
    SET_PREVIOUS_MAIL_DRAFT (state, payload){
        state.preMailDraft = payload
    },
    SET_MODE(state) {
        state.mode = !state.mode
    },
}